import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { images, stackItems } from "../../data/content";
import { CtaButton } from "../ui/CtaButton";
import { Countdown } from "../ui/Countdown";
import { ScarcityBar } from "../ui/ScarcityBar";
const perks = ["One-Time Payment", "Instant Digital Access", "Lifetime Access to Purchased Materials", "No Monthly Subscription"];
export function OfferSection() {
  const total = stackItems.reduce((sum, i) => sum + i.value, 0);
  return <section id="offer" className="bg-navydeep px-5 py-16 sm:py-24" data-id="element-189" data-mp="1q81kkdl68of">
      <div className="mx-auto max-w-3xl" data-id="element-190" data-mp="3swsopt0iswg6">
        <div className="text-center" data-id="element-191" data-mp="3sxubguqwf7dq">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-cyan" data-id="element-192" data-mp="3suoopm5qshl6">Your Complete Endo Blueprint™ Package</p>
          <h2 className="mt-3 font-display text-[2rem] font-extrabold leading-tight text-white sm:text-5xl" data-id="element-193" data-mp="3iyd8il3177lg">
            Here's Everything You'll Receive Today
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-paper shadow-[0_24px_60px_rgba(0,0,0,0.35)]" data-id="element-194" data-mp="1as0n02sn5izy">
          <img src={images.hero} alt="Everything included in Endo Blueprint" className="w-full bg-cream" data-id="element-195" data-mp="1fiqublkmnvxa" />
          <div className="p-5 sm:p-8" data-id="element-196" data-mp="10u4e7hn6f050">
            <ul className="divide-y divide-line" data-id="element-197" data-mp="10v5srw3ei4rh">
              {stackItems.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-198" data-mp="15tpepwhzvgju">
                  <span className="flex gap-2.5 text-[16px] font-semibold leading-snug text-ink" data-id="element-199" data-mp="1tjth60jg5a99">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-200" data-mp="1yga4isitnkla" />
                    {item.label}
                  </span>
                  <s className="shrink-0 text-[16px] font-bold text-danger" data-id="element-201" data-mp="1ojf587eq5g5y">${item.value}</s>
                </li>)}
            </ul>
            <div className="mt-4 flex items-center justify-between rounded-xl bg-cream px-4 py-3" data-id="element-202" data-mp="91vjojaxchv2">
              <span className="text-sm font-extrabold uppercase tracking-wide text-ink" data-id="element-203" data-mp="d51kvcj6jiuo">Total reference value</span>
              <s className="font-display text-2xl font-bold text-danger" data-id="element-204" data-mp="2fq5n9y8gbdkl">${total}</s>
            </div>

            <div className="mt-8 text-center" data-id="element-205" data-mp="2asm7uv00our2">
              <p className="text-lg font-semibold text-muted" data-id="element-206" data-mp="260m1oktct5m1">
                You don't have to pay <s data-id="element-207" data-mp="212at0desp15e">${total}</s>. You don't have to pay <s data-id="element-208" data-mp="2119hk7tvacn5">$97</s>.
              </p>
              <p className="mt-4 text-sm font-extrabold uppercase tracking-wider text-navy" data-id="element-209" data-mp="2106pvxoq0666">
                Today, get the complete Endo Blueprint™ for just:
              </p>
              <p className="mt-1 font-display text-7xl font-black leading-none text-cta sm:text-8xl" data-id="element-210" data-mp="1s01ihnjj17s0">$27</p>
              <p className="mt-1 text-base font-bold text-ink" data-id="element-211" data-mp="1n4chdfruzitl">USD · One-time payment</p>
              <p className="mx-auto mt-3 flex max-w-md items-center justify-center gap-2 rounded-full bg-cyansoft px-4 py-2 text-sm font-semibold text-navy" data-id="element-212" data-mp="1i4zvoycq4hsl">
                <GlobeIcon className="h-4 w-4 shrink-0 text-cyan" aria-hidden="true" data-id="element-213" data-mp="3cgy44y37l9nf" />
                Price converts automatically to your local currency
              </p>
            </div>

            <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-x-4 gap-y-2" data-id="element-214" data-mp="3oza7ngq5pu5o">
              {perks.map(p => <li key={p} className="flex gap-2 text-sm font-semibold leading-snug text-ink" data-id="element-215" data-mp="3trjwetfjco6d">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-216" data-mp="2j5ypuevaw1c" />
                  {p}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-217" data-mp="360o5dyiwlx06">
              <ScarcityBar data-id="element-218" data-mp="361pj6arb0xll" />
            </div>

            <div className="mt-6" data-id="element-219" data-mp="362r4d821b0h1">
              <CtaButton label="Get the Endo Blueprint™ for $27" data-id="element-220" data-mp="3azrb7l6pk797" />
              <p className="mt-4 flex items-center justify-center gap-1.5 text-center text-sm text-muted" data-id="element-221" data-mp="3fz40sdoyrsfh">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="qa1ypeth8xjo" />
                Secure Checkout · Instant Digital Delivery · 7-Day Guarantee
              </p>
              <Countdown data-id="element-223" data-mp="v71vt08cmpyn" />
            </div>

            <p className="mt-8 text-center text-[15px] leading-relaxed text-ink/80" data-id="element-224" data-mp="245bema2xclbq">
              For less than the cost of many professional educational resources, you'll receive a visual reference system
              designed to help you organize your endodontic knowledge and structure your initial case review.
            </p>
            <p className="mt-4 text-center text-xs italic text-muted" data-id="element-225" data-mp="286n9au0nnwqs">
              All reference values are proposed pricing anchors, not independently verified market valuations.
            </p>
          </div>
        </div>
      </div>
    </section>;
}